module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("When I returned to the house I found Dad on the dock in his black police uniform. His shirt collar is decorated with stars, and his badge glinted in the sun. He wears a utility belt that weighs nearly ten pounds, with his 9mm Glock pistol, two sets of handcuffs, Taser, and flashlight. As if the badge and the belt weren’t enough to scare a criminal, his arms are nearly as big around as my leg and his muscles strain against his shirtsleeves.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dad’s project of the day was wiring the engine on the new boat lift for the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bream Chaser")]), _vm._v(". That’s what Dad had named my boat. I think it was his attempt at making a joke, a bream being a small perchlike fish. Since the fight, he’d been making more jokes and I figured it was his way of gauging my enthusiasm. Outside of his occasional not-funny jokes, Dad’s pretty serious. He’s always thinking about work and projects, but even more so since we’d moved to Kings Bayou.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dad’s originally from Bay St. Louis, a coastal town not far west of Pascagoula. He grew up fishing and boating the Gulf of Mexico with his friends and my grandfather. While we were living in McComb and he was still a sergeant, all he talked about was moving south again. Then he got the new job at the end of last summer. Being chief of a police department was the goal he’d been working toward since the academy. As soon as we moved he bought a waterfront lot on the bayou and began building his dream house. The construction workers had finished in March, and we’d been living in it for almost four months.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I tied the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bream Chaser")]), _vm._v(" to the dock, trying to remember the knot Dad had taught me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Catch anything?” he called out.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No, sir,” I said. I knew he was watching me fumble with the rope. The knot is called a bowline. It’s supposedly the best knot in the world. It looks easy when he makes it, but I only get it right half the time.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Make a loop,” he said. “Then the rabbit comes out of the hole and around the tree.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I fumbled it again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dad walked over and knelt beside me. “You just gotta make your rabbit hole the right way,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He made his first loop and quickly pushed the rope end out of the hole, around the stupid tree, and back down the hole, cinching the knot tight.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Takes a little practice,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t see how it was possible to learn everything he knew, but I wanted to try.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m going inside to get something to eat,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I walked up the dock and into the house and saw Mom in the kitchen putting a corned beef into the Crock-Pot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“How was it?” she asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Fine,” I said. “But I didn’t catch anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Are you hungry?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, ma’am.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“This corned beef won’t be ready until supper, but you can grab a snack to tide you over.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sounds good,” I said. “I’m going to put my stuff away.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Grover left two messages for you on the answering machine.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Okay,” I said. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("The television in my room was full of Xbox messages from Grover. The good thing about him never using his boat was that he couldn’t come after me. But I doubted he even realized I was avoiding him. Things like that didn’t seem to register with Grover.")]), _vm._v(" "), _c('p', {
    staticClass: "EMEX"
  }, [_c('span', {
    staticClass: "SANS-R"
  }, [_vm._v("Where are you?")])]), _vm._v(" "), _c('p', {
    staticClass: "EMEX"
  }, [_c('span', {
    staticClass: "SANS-R"
  }, [_vm._v("Call me.")])]), _vm._v(" "), _c('p', {
    staticClass: "EMEX"
  }, [_c('span', {
    staticClass: "SANS-R"
  }, [_vm._v("Something wrong with your stinking phone?")])]), _vm._v(" "), _c('p', {
    staticClass: "STXS"
  }, [_vm._v("Ignoring Grover’s communication attempts just annoyed him and made him pound out text messages in all capital letters.")]), _vm._v(" "), _c('p', {
    staticClass: "EMEX"
  }, [_c('span', {
    staticClass: "SANS-R"
  }, [_vm._v("WHERE ARE YOU????")])]), _vm._v(" "), _c('p', {
    staticClass: "EMEX"
  }, [_c('span', {
    staticClass: "SANS-R"
  }, [_vm._v("GET ONLINE!")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("I turned away from the screen and flopped onto my bed. I lay there and stared at the blades of the ceiling fan and got my head back into the adventure I’d had that morning. First I thought about Davey and how strange it was that he was out there by himself. Then I thought about the dead body and how ridiculous it was to think I could find it. Davey and the swamp camp were suddenly more interesting than the dead body. But the more I thought about it, the more Davey’s story didn’t sit right with me. There were a lot of pieces missing. The mystery of it was enticing, but I also couldn’t think of ever doing something that made me feel so different.")]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("The Xbox chirped.")]), _vm._v(" "), _c('p', {
    staticClass: "EMEX"
  }, [_c('span', {
    staticClass: "SANS-R"
  }, [_vm._v("ANSWER ME!")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("I grabbed my backpack off the floor and returned to the kitchen. Mom had gone onto the sun porch to touch up one of her paintings. She used to work as a legal secretary when we lived in McComb. She was always coming home late and dumping stacks of take-home work on the kitchen counter. She said as soon as she and Dad saved up enough money for the move to Pascagoula she was going to find less stressful work and take up painting again, something she’d enjoyed in college. She works part-time as the secretary at our church now, and when she’s not working she spends a lot of her free time creating oil paintings of the water and the wildlife outside the window. She doesn’t sell them, but to me they look as good as anything you’d see in a gallery. I was sort of surprised by how good they were, but Mom’s like that. It seems like she’s quietly good at everything.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Mom had left out a sandwich for me and I stuffed it down. Then I put my backpack on the counter and began to fill it. I got three cans of ravioli, two cans of corned beef hash, two bananas, a bag of potato chips, four hot dogs, and several slices of cheese. Then I filled an empty milk jug with water and set it on the counter beside the pack. Finally, I filled an empty pill bottle with milk and put it in a Ziploc bag with an eyedropper Mom used to use to give me medicine.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A sleeping bag was going to be a problem. There was no way I could get one into my pack and it was probably too hot for one anyway. I decided to take two old bedsheets instead. It was enough to give Davey a little comfort and to block mosquitoes until his family arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Just as I was about to go out the back door I heard the phone ringing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Can you get that, Sam?” Mom called from the sun porch. “It’s probably Grover again.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Okay,” I said with a groan.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I went into the kitchen, put everything on the floor, and picked up the handset.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hello,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Why haven’t you been communicating with me?” Grover said. He was always impatient but even more so on the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Because I’ve been too busy to play Xbox.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Busy doing what?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ve been in the boat.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ve been fishing.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t know, Grover. Because sometimes people go fishing.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What’s the point in it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s just fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You never liked to fish before.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes I did. Dad just hasn’t had much time to take me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Geez, Grover. It’s only been like a day since I was online.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well, you have a lot of catching up to do. I’m at level three on Demon Quest.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll catch up.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Tomorrow, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Come over after church. We can stay up late.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I looked at the floor. It was easy to avoid Grover in my head, but it was much harder to avoid him face-to-face, or ear to ear in this case.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Okay,” I said, feeling like a coward. “Are you going?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I hadn’t seen him at church in weeks, and I assumed his mother had been traveling. Dr. Middleton didn’t attend service, and I never saw Grover there unless his mother took him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah, I’ll be there,” Grover said, like it was a dumb question.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“All right, then,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Good,” he said. “See you tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The phone clicked and went silent.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("Dad was still working on the boat lift at the end of the dock. He straightened and eyed my backpack.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Getting serious about fishing, I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I guess. Mostly exploring.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’ll get the hang of it. Look for structure along the bank, and fish against it. Before you know it, you’ll drag a big redfish out of there.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll try.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He studied me, beaming. It was obvious that he liked nothing more than to see me enjoying the boat. It was just the type of outdoor thing he thought I should be doing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You show Grover your boat yet?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He doesn’t care about that kind of thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Maybe he just doesn’t know what he’s missing. I’ll bet some pretty girls would love to go riding with you two.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I thought of Julia in my boat. I imagined her sitting on the front seat and looking back at me with that smile and that blond hair blowing about her face.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I frowned. “I doubt it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You might be surprised,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He wasn’t even close to understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I haven’t been hanging out with Grover as much lately.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I studied Dad’s face, searching for some sign of approval, but his expression didn’t change.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Why not?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t know. I’m just not into the Xbox as much, I guess. That’s all he likes to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’m not sure what Dad thinks of Grover. Like everybody else I know, he probably just can’t imagine how you connect with him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dad turned back to the lift. “I think you’d be doing him a favor to stop off and get him out of the house some.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll see him at church tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Suit yourself,” Dad said. “Have a good time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I got into the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bream Chaser")]), _vm._v(" with my backpack, started the engine, and sped away toward the strange world of the swamp and Davey. Where, if even for just a little while, I didn’t have to worry about who I was and who I hung out with.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-576411e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 78
// module chunks = 0